import {Component, OnInit} from '@angular/core';
import {RelayBoard} from '../../../classes/RelayBoard';
import {RelayBoardService} from '../../../services/relay-board.service';
import {RelayScriptRuleService} from '../../../services/relay-script-rule.service';
import {RelayScriptRule} from '../../../classes/RelayScriptRule';
import {FormGroup} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RelayScriptRuleEditComponent} from '../relay-script-rule-edit/relay-script-rule-edit.component';
import {TimePeriodService} from '../../../services/time-period.service';
import {TimePeriod} from '../../../classes/TimePeriod';
import {Relay} from '../../../classes/Relay';
import {RelayService} from '../../../services/relay.service';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';

@Component({
  selector: 'app-relay-script-rule-list',
  styleUrls: ['./relay-script-rule-list.component.scss'],
  templateUrl: './relay-script-rule-list.component.html',
})
export class RelayScriptRuleListComponent implements OnInit {

  private currentDialog = null;
  protected relayBoards: Map<number, RelayBoard>;
  protected timePeriods: Map<number, TimePeriod>;
  protected relays: Map<number, Relay>;
  protected offices: Map<number, Office>;

  public errorMessage: string;
  public relayScriptRules: RelayScriptRule[];

  constructor(private modalService: NgbModal,
              private relayService: RelayService,
              private officeService: OfficeService,
              private relayBoardService: RelayBoardService,
              private timePeriodService: TimePeriodService,
              private relayScriptRuleService: RelayScriptRuleService) {
  }

  ngOnInit(): void {
    this.updateList();
    this.relayBoardService.getAll()
      .subscribe((response: RelayBoard[]) => this.relayBoards = new Map(response.map(board => [board.id, board])));

    this.timePeriodService.getAll()
      .subscribe((response: TimePeriod[]) => this.timePeriods = new Map(response.map(period => [period.id, period])));

    this.relayService.getAll()
      .subscribe((response: Relay[]) => this.relays = new Map(response.map(relay => [relay.id, relay])));

    this.officeService.getAll()
      .subscribe((response: Office[]) => this.offices = new Map(response.map(office => [office.id, office])));
  }

  private updateList(): void {
    this.relayScriptRuleService.getAll()
      .subscribe({
        next: (response: RelayScriptRule[]) => this.relayScriptRules = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(relayScriptRule: RelayScriptRule): void {
    this.currentDialog = this.modalService.open(RelayScriptRuleEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-relay-script-rule-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.relayScriptRule = relayScriptRule;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedRelayScriptRule = new RelayScriptRule(result.value);

          this.relayScriptRuleService.addOrEdit(editedRelayScriptRule).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(relayScriptRule: RelayScriptRule): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete relay script rule?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.relayScriptRuleService.delete(relayScriptRule.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getRelayBoardName(relayBoardId: number): string {
    return this.relayBoards.get(relayBoardId).name;
  }

  getTimePeriodName(timePeriodId: number): string {
    return this.timePeriods.get(timePeriodId).name;
  }

  getRelayName(relayId: number): string {
    return this.relays.get(relayId).name;
  }

  getOfficeName(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }
}
